"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _immutable = require("immutable");

var _once = _interopRequireDefault(require("playbooks-modal/utils/once"));

var _EngagementTypes = require("customer-data-objects/engagement/EngagementTypes");

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _UISelect = _interopRequireDefault(require("UIComponents/input/UISelect"));

var convertCallDispositionsToOptions = (0, _once.default)(function (callDispositions) {
  return callDispositions.map(function (text, value) {
    return {
      value: value,
      text: text
    };
  }).toArray();
});

var PlaybooksModalFooterSelectCallDisposition = function PlaybooksModalFooterSelectCallDisposition(props) {
  var engagementType = props.engagementType,
      callDisposition = props.callDisposition,
      callDispositions = props.callDispositions,
      onCallDispositionChange = props.onCallDispositionChange,
      rest = (0, _objectWithoutProperties2.default)(props, ["engagementType", "callDisposition", "callDispositions", "onCallDispositionChange"]);

  if (callDispositions.isEmpty() || engagementType !== _EngagementTypes.CALL) {
    return null;
  }

  return _react.default.createElement(_UISelect.default, (0, _extends2.default)({
    buttonUse: "transparent",
    searchable: false,
    menuWidth: 200,
    placeholder: _react.default.createElement(_FormattedMessage.default, {
      message: "playbooksModal.footer.selectAnOutcome"
    }),
    onChange: function onChange(e) {
      return onCallDispositionChange(e.target.value);
    },
    options: convertCallDispositionsToOptions(callDispositions),
    value: callDisposition
  }, rest));
};

PlaybooksModalFooterSelectCallDisposition.propTypes = {
  engagementType: _react.PropTypes.string.isRequired,
  callDisposition: _react.PropTypes.string,
  callDispositions: _react.PropTypes.instanceOf(_immutable.OrderedMap).isRequired,
  onCallDispositionChange: _react.PropTypes.func.isRequired
};
var _default = PlaybooksModalFooterSelectCallDisposition;
exports.default = _default;
module.exports = exports.default;